import styles from './AnnotationLabel.module.css';

// 注釈ラベル／寸法線（DESIGN §8.3）。図面の引き出し線のように要素へ小さな注釈を添える。
// 落款印の「存在感」を、製図的な注釈で置き換えるための要素。
type Props = {
  /** 欧文ラベル（DIN・全大文字・広トラッキング）。 */
  en?: string;
  /** 和文ラベル。 */
  label?: string;
  /** 数値（タブラー）。例: 第 03 号。 */
  value?: string;
  /** リード線の向き。 */
  tick?: 'left' | 'right' | 'none';
  className?: string;
};

export default function AnnotationLabel({
  en,
  label,
  value,
  tick = 'left',
  className,
}: Props) {
  const cls = [styles.root, tick !== 'none' && styles[`tick-${tick}`], className]
    .filter(Boolean)
    .join(' ');
  return (
    <span className={cls}>
      {tick !== 'none' && <span aria-hidden="true" className={styles.lead} />}
      <span className={styles.text}>
        {en && <span className={styles.en}>{en}</span>}
        {label && <span className={styles.label}>{label}</span>}
        {value && <span className={styles.value}>{value}</span>}
      </span>
    </span>
  );
}
